













import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { AdminContentItemRoutes } from '@/modules/content-item/routes/admin-content-item.route'


@Component({
  inheritAttrs: false,
  components: {}
})
export default class CampaignItemLink extends Vue {

  constructor(
    private readonly contentItemRoute: AdminContentItemRoutes
  ) {
    super()
  }

  @Prop({ required: true }) itemId: number
  @Prop({ required: true }) itemType: string
  @Prop() text: string

  showUrl() {
    if (this.itemType.match(/content/i))
      return this.contentItemRoute.show(this.itemId)
    else return '#'
  }

}
